module Meevo.Components.HostedPage {
    'use strict';

    interface IHostedPageComponentBindings {
    }

    interface IHostedPageComponentController extends IHostedPageComponentBindings {
    }

    export class HostedPageComponentController implements IHostedPageComponentController {
    }

    export class HostedPageComponent implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public templateUrl: string;

        constructor() {
            this.bindings = {
            };

            this.controller = HostedPageComponentController;
            this.templateUrl = 'app/components/hostedPage/hostedPage.template.html';
        }
    }

    angular.module('meevo.components.hostedPage')
        .component('meevoHostedPage', new HostedPageComponent());
}